import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import api from '../utils/api';

const GoogleCallback = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double-processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Extract session_id from URL hash fragment (Emergent Auth returns #session_id=xxx)
    const hash = window.location.hash;
    let sessionId = null;
    if (hash && hash.includes('session_id=')) {
      const params = new URLSearchParams(hash.substring(1));
      sessionId = params.get('session_id');
    }
    // Also check query params as fallback
    if (!sessionId) {
      const searchParams = new URLSearchParams(window.location.search);
      sessionId = searchParams.get('session_id') || searchParams.get('session_token');
    }

    if (!sessionId) {
      setError('No session received from Google');
      return;
    }

    const completeLogin = async () => {
      try {
        const response = await api.post('/auth/google/callback', { session_id: sessionId });
        loginWithToken(response.data.token, response.data.user);
        toast.success('Signed in with Google!');
        navigate('/');
      } catch (err) {
        setError('Failed to complete Google login');
        toast.error('Google login failed');
      }
    };

    completeLogin();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4" data-testid="google-callback-error">
        <div className="text-center space-y-4">
          <h2 className="font-heading text-2xl text-forest">Login Failed</h2>
          <p className="text-muted-foreground">{error}</p>
          <button onClick={() => navigate('/login')} className="bg-forest text-ivory px-6 py-3 text-sm uppercase tracking-[0.1em]" data-testid="back-to-login-button">
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="google-callback-loading">
      <p className="text-muted-foreground">Completing Google login...</p>
    </div>
  );
};

export default GoogleCallback;
